export const defaultFontFamily = 'Helvetica, Arial, sans-serif'
